import * as React from 'react';
import './LoginBanner.css';

export const LoginBanner: React.StatelessComponent<{}> = () => {
    return (
        <div className="login-banner-container">
            <div className="login-banner-content">
                <div className="login-banner-message">
                    <b>We will be performing system maintenance and updates between Friday, March 27th at 6pm and Monday, March 30th at 8am.</b> Some features may not work as expected. We appreciate your patience — we'll be fully back up and running with exciting new updates on <b>Monday, March 30th at 8:00 AM.</b> Thank you!
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/layout/LoginBanner.tsx